/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MallPopup from './MallPopup';
import AddressDesc from './AddressDesc';
import TransferDom from "vux/src/directives/transfer-dom/index.js";
import Checker from "vux/src/components/checker/checker.vue";
import CheckerItem from "vux/src/components/checker/checker-item.vue";
export default {
  components: {
    TransferDom: TransferDom,
    MallPopup: MallPopup,
    AddressDesc: AddressDesc,
    Checker: Checker,
    CheckerItem: CheckerItem // Popover

  },
  directives: {
    TransferDom: TransferDom
  },
  props: {
    active: {
      type: Boolean,
      "default": false
    },
    addressList: Array,
    nowSelected: ''
  },
  data: function data() {
    return {
      show: this.active,
      selectedFilter: ''
    };
  },
  watch: {
    active: function active(newVal) {
      this.show = newVal;
    },
    show: function show(val) {
      this.$emit('setShow', val);

      if (val) {
        this.$bus.$emit('unique-show', this);
      }
    }
  },
  computed: {},
  created: function created() {
    var _this = this;

    console.log(this.addressList);

    if (this.nowSelected) {
      this.selectedFilter = this.nowSelected;
      console.log(2);
    }

    this.$bus.$on('unique-show', function (target) {
      if (target !== _this) {
        _this.show = false;
      }
    });
  },
  mounted: function mounted() {},
  methods: {
    newAddress: function newAddress() {
      this.$router.push({
        name: 'MallAddress'
      });
    },
    editAddress: function editAddress(userAddressId) {
      console.log(userAddressId);
      this.$emit('editAddress', userAddressId);
    },
    itemClick: function itemClick() {
      this.show = false;
      console.log(3);
      this.$emit('itemCheck', this.selectedFilter);
    }
  }
};